import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import horseUrlBuilder from './urlBuilder';

const ColumnSireName = ({ data, rowData }) => (
    data === '—' ? <span>—</span> : (
        <a
            href={horseUrlBuilder(rowData.sire_uid, rowData.sire_style_name)}
            className="js-popupLink ui-link ui-link_table"
        >
            {data}
            <Svg
                iconName="right"
                size="XSmall"
            />
        </a>
    )
);

ColumnSireName.propTypes = {
    rowData: PropTypes.object,
    data: PropTypes.string
};

export default ColumnSireName;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/ColumnSireName.js